// ═══════════════════════════════════════════════════════════
// TYPES & INTERFACES
// ═══════════════════════════════════════════════════════════

export enum GameState {
    MENU = 'MENU',
    PLAYING = 'PLAYING',
    GAME_OVER = 'GAME_OVER',
    PAUSED = 'PAUSED'
}

export enum BallState {
    MOVING = 'MOVING',
    AIMING = 'AIMING',
    LAUNCHING = 'LAUNCHING'
}

export interface Vector2 {
    x: number;
    y: number;
}

export interface Bounds {
    width: number;
    height: number;
    offsetY?: number; // Y offset for game area (to account for HUD)
}

export interface Corner {
    position: Vector2;
    type: CornerType;
    glowIntensity: number;
    hitCount: number;
}

export enum CornerType {
    TOP_LEFT = 'TOP_LEFT',
    TOP_RIGHT = 'TOP_RIGHT',
    BOTTOM_LEFT = 'BOTTOM_LEFT',
    BOTTOM_RIGHT = 'BOTTOM_RIGHT'
}

export interface Particle {
    position: Vector2;
    velocity: Vector2;
    life: number;
    maxLife: number;
    size: number;
    color: string;
    alpha: number;
}

export interface ScorePopup {
    position: Vector2;
    text: string;
    life: number;
    maxLife: number;
    velocity: Vector2;
    color: string;
}

export interface GameConfig {
    canvasWidth: number;
    canvasHeight: number;
    ballSize: number;
    ballSpeed: number;
    cornerHitRadius: number;
    initialTime: number;
    timeBonus: number;
    trailLength: number;
    particleCount: number;
}

export interface DifficultyConfig {
    level: number;
    cornerHitRadius: number;
    aimOscillationSpeed: number;
}

export interface AudioConfig {
    volume: number;
    muted: boolean;
}

export interface Obstacle {
    position: Vector2;
    velocity: Vector2;
    size: number;
    rotation: number;
    pulsePhase: number;
}

export interface Boost {
    position: Vector2;
    size: number;
    pulsePhase: number;
    glowIntensity: number;
}

export interface PointPickup {
    position: Vector2;
    size: number;
    value: number;
    pulsePhase: number;
    glowIntensity: number;
    rotationAngle: number;
}
